import React from 'react';
import { Radio } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from '@/components/Settings/DataExtraction/styles';

export function ExtractActionPlansFormItem() {
	return (
		<S.FormItemWrapper
			name={['reports', 'has_action_plan_extraction']}
			label={
				<S.BodyLargeRegular>
					{I18n.get('Do you want to extract the action plans from the report(s)?')}
				</S.BodyLargeRegular>
			}
			labelCol={{ span: 24 }}
			wrapperCol={{ span: 24 }}
			rules={[{ required: true, message: I18n.get('This field is required') }]}
		>
			<Radio.Group>
				<Radio value={true}>
					<S.LabelMediumRegular>{I18n.get('Yes')}</S.LabelMediumRegular>
				</Radio>
				<Radio value={false}>
					<S.LabelMediumRegular>{I18n.get('No')}</S.LabelMediumRegular>
				</Radio>
			</Radio.Group>
		</S.FormItemWrapper>
	);
}
